import { PerspectiveCamera, type Camera } from 'three'
import type { MapControls } from 'three/examples/jsm/controls/MapControls.js'
import type { KeyDownReactiveMap } from '../../rx/reactive_map/useKeyDownReactiveMap'
import { useEngineModeSignal } from '../../rx/signal/useEngineModeSignal'
import { Engine } from './engine/Engine.type'
import { EngineMode } from './engine/EngineMode/EngineMode.enum'
import { abs, max, min } from './util/math/Math'
import { getEngineKeyDownReactiveMap } from '../three/fn/getSetEngineKeyDownReactiveMap'
import { createComputed } from 'solid-js'
import createSharedCachedFactory from '../../rx/memo/createSharedCachedFactory'

const MAX_VELOCITY = 100
const PAN_MULT = 0.05
const FRICTION = 1.6

export const useProgressArrowKeyPan = createSharedCachedFactory((
  engine: Engine
) => {
  const [getEngineMode] = useEngineModeSignal(engine)
  let keyDownReactiveMap: KeyDownReactiveMap
  createComputed(() => {
    keyDownReactiveMap = getEngineKeyDownReactiveMap(engine)
  })

  let pan_vx: number = 0
  let pan_vy: number = 0

  return function progressArrowKeyPan(
    elapsedMs: number,
    camera: Camera,
    mapControls: MapControls,
  ): void {
    if (getEngineMode() === EngineMode.ArmyPainter) {
      return
    }

    // const { ArrowRight, ArrowLeft, ArrowDown, ArrowUp } = keyDownReactiveMap
    const ArrowRight = keyDownReactiveMap.get('ArrowRight')
    const ArrowLeft = keyDownReactiveMap.get('ArrowLeft')
    const ArrowDown = keyDownReactiveMap.get('ArrowDown')
    const ArrowUp = keyDownReactiveMap.get('ArrowUp')

    // console.log('progressArrowKeyPan', engine.pan_vx, engine.pan_vy)

    const framePanMult = elapsedMs * PAN_MULT

    // Update velocity based on arrow keys
    if (ArrowRight && !ArrowLeft) {
      pan_vx = max(pan_vx - framePanMult, -MAX_VELOCITY)
    } else if (ArrowLeft && !ArrowRight) {
      pan_vx = min(pan_vx + framePanMult, MAX_VELOCITY)
    } else if (pan_vx !== 0) {
      pan_vx /= FRICTION
    }
    if (ArrowDown && !ArrowUp) {
      pan_vy = max(pan_vy - framePanMult, -MAX_VELOCITY)
    } else if (ArrowUp && !ArrowDown) {
      pan_vy = min(pan_vy + framePanMult, MAX_VELOCITY)
    } else if (pan_vy !== 0) {
      pan_vy /= FRICTION
    }
    // console.log('progressArrowKeyPan', pan_vx, pan_vy, deepCloneMap(keydownMap))

    // Zero out small velocities
    if (abs(pan_vx) < 0.1) {
      pan_vx = 0
    }
    if (abs(pan_vy) < 0.1) {
      pan_vy = 0
    }

    ; (mapControls as unknown as ({
      _pan: (x: number, y: number) => void
    }))._pan(pan_vx, pan_vy)

    if (camera instanceof PerspectiveCamera) {
      camera.updateProjectionMatrix()
    }
    // engine.pan_vx = pan_vx
    // engine.pan_vy = pan_vy
  }
})




